// import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { food_menu_api } from "../constants";
// import Menu from "./Menu";
import Shimmer from "./Shimmer";
import useRestaurant from "../utils/useRestaurant";
// import RestaurantCategory from "./RestaurantCategory";
import {useDispatch} from "react-redux";
import { addItem } from "../utils/cardSlice";

const RestaurantMenu = () => {
     //reading the dynamic url params
     const params = useParams();
     const { id } = params;
     console.log(params);

     // const [restaurant, setRestaurant] = useState({});

     const restaurant = useRestaurant(id);
     // useEffect(() => {
     //      getRestaurantInfo();
     // },[]);

     // const [cnt, setcnt] = useState(0);

     /* async function getRestaurantInfo() {
           // const data = await fetch(food_menu_api +  {id});
           // const json = await data.json();
           // console.log(json.data);
           // setRestaurant(json.data);
           const data = food_menu_api;
           setRestaurant(data);
      }*/

     //  const {itemCards} = restaurant?.cards[2]?.groupedCard?.cardGroupMap?.REGULAR?.cards[1]?.card?.card;

     //  const categories = restaurant?.cards[2]?.groupedCard?.cardGroupMap?.REGULAR?.cards.filter((c)=> c.card?.["card"]?.["@type"]=== "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory");


     const dispatch = useDispatch();
     const handleAddItem = (item) =>{
          dispatch(addItem(item));
     }


     return (!restaurant) ? <Shimmer /> : (
          <div
               // className="mainCardDiv"
               className="flex flex-wrap m-4 p-4 justify-center items-center"
          >
               <div
                    // className="menuCard"
                    className="flex-wrap m-4 p-4  items-center justify-center bg-blue-100 border border-solid border-black"
               >
                    <div
                         // className="menudiv"
                         className="flex flex-wrap m-4 p-4 items-center"
                    >
                         <img className="w-20 rounded-lg" src={food_menu_api[id - 1]?.img}
                              //  className="menuimg" 
                              alt="" />
                         <div className="px-4 m-4 font-extrabold"> {food_menu_api[id - 1]?.name}</div>
                         <div className="px-4 m-4 font-bold ">Price -₹{food_menu_api[id - 1]?.price}</div>
                         <div className="px-4 font-bold" >Rating: {food_menu_api[id - 1]?.rate} stars</div>
                         <div className="px-4 font-bold">Country: {food_menu_api[id - 1]?.country}</div>

                    </div>

               </div>
               <div className="menuList">
                    <h1 className="flex bg-red-400 h-12 justify-center items-center from-neutral-800 font-bold text-4xl">MENU</h1>
                    <ul className="itemList">
                         <div className="flex flex-wrap items-center justify-center bg-gradient-to-r from-gray-100 via-[#bce1ff] to-cyan-100">
                              {food_menu_api.map((item) => (
                                   <div className="m-5 p-5 bg-amber-100 flex-wrap h-25 rounded-xl w-[200px] h-[250px]">
                                   <button className="mt-0 absolute p-1 bg-white shadow-lg m-auto rounded-lg font-bold"
                                    onClick={()=> handleAddItem(item)}>Add</button>
                                        <div key={item?.id} className="m-2 p-2 w-[120px] h-[120px] items-center justify-center">
                                        <img src = {item?.img} alt="" className="rounded-lg"></img>
                                        </div>
                                        <li key={item?.id} className="font-bold">{item?.name}</li>
                                        <li key={item?.id}>Price:-₹{item?.price}</li>
                                        <li key={item?.id}>Rating:{item?.rate}</li>
                                        
                                   </div>
                              ))}
                         </div>
                    </ul>
               </div>

               
               {/* <div className="text-center">
                    <h1 className="font-bold my-6 text-2xl">{name}</h1>
                    <p className="font-bold text-lg">
                         {cuisines.join(",")} -{costForTwoMessage}
                    </p>
                    {categories.map((category)=>{
                         <RestaurantCategory key={category?.card?.card.title}
                          data={category?.card?.card} showItems={false}/>
                    })}
               </div> */}

          </div>
     );
}
export const i = (id) => {
     return id;
}


export default RestaurantMenu;